export default __webpack_public_path__ + "static/media/status-not-available.feff11ab.svg";